module.exports = "static/assets/b3a6f3783f393f641dc3e51211dd50f4.svg";